// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__1eAqB","content":"styles_content__1TqLM","checkbox":"styles_checkbox__3XJRv","checkboxLabel":"styles_checkboxLabel__1MaVZ"};